export default __webpack_public_path__ + "static/media/Prince_Harry_0002.fa6c0261.jpg";